__turbopack_context__.v({
  "continueLink": "cart-empty-module__GPfqsa__continueLink",
  "message": "cart-empty-module__GPfqsa__message",
  "retry": "cart-empty-module__GPfqsa__retry",
  "root": "cart-empty-module__GPfqsa__root",
  "stateText": "cart-empty-module__GPfqsa__stateText",
  "supporting": "cart-empty-module__GPfqsa__supporting",
});
